import axios from 'axios'

/** One pooled DAT token's usage, aggregated over the selected window. */
export interface DatTokenUsageItem {
    userId: string
    totalUses: number
    byTrigger: Record<string, number>
    lastUsedDay: string | null
    activeDays: number
    /** Token owner's project (resolved server-side; null if unmapped). */
    projectName: string | null
    /** Company display name with projectName fallback; null if unmapped. */
    companyName: string | null
}

export interface DatTokenUsageSummary {
    totalUses: number
    uniqueTokens: number
    byTrigger: Record<string, number>
}

export interface DatTokenUsagePage {
    rows: DatTokenUsageItem[]
    total: number
    totalPages: number
    summary: DatTokenUsageSummary
}

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

export interface DatTokenUsageParams {
    page: number
    pageSize: number
    fromDay?: string
    toDay?: string
    trigger?: string
    /** Substring match on the token owner's user ID. */
    search?: string
    /** Substring match on projectName / company name. */
    project?: string
    sortBy?: 'uses' | 'userId'
}

export const datTokenUsageApi = {
    // baseURL already includes /v1 (see setup/SetupAxios). Route is registered in
    // main-service at /v1/gluon/dat-token-usage.
    getUsage: async (params: DatTokenUsageParams): Promise<DatTokenUsagePage> => {
        const res = await axios.get<Envelope<DatTokenUsagePage>>('/gluon/dat-token-usage', { params })
        return res.data.data
    },
}
